import axios from 'axios';
import { base_url_api } from './keys';

const FBMHttp = async (path = "", method = 'get', data = {}) => {
    //console.log(method, path, data);
    let response = false;
    
    if(method.toLowerCase() == 'get'){
        // GET Method 
        response = await axios.get(`${base_url_api}${path}`);

    }else if(method.toLowerCase() == 'post'){
        // POST Method
        response = await axios.post(`${base_url_api}${path}`, data);
    }

    return response;
}

export { FBMHttp };